import { render } from "./Expenses.vue?vue&type=template&id=9e2868a6&scoped=true&bindings={}"
import script from "./Expenses.vue?vue&type=script&lang=ts"
export * from "./Expenses.vue?vue&type=script&lang=ts"

import "./Expenses.vue?vue&type=style&index=0&id=9e2868a6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9e2868a6"

export default script